export async function clearServiceWorker(): Promise<void> {
    if ( navigator?.serviceWorker ){
        await navigator.serviceWorker.getRegistrations()
          .then(registrations => {
            for (const registration of registrations) {
                registration.unregister();
            } 
          })
    }
}